<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M9.99925 12.6562V15.1562M9.99925 12.6562H6.27194C5.86579 12.6562 5.48496 12.4589 5.25073 12.1271L4.25809 10.7209C3.95303 10.2887 3.95303 9.71131 4.25809 9.27915L5.25073 7.8729C5.48496 7.54108 5.86579 7.34375 6.27194 7.34375H9.37425C9.71943 7.34375 9.99925 7.62357 9.99925 7.96875V12.6562ZM10.6242 4.84375H13.7266C14.1327 4.84375 14.5135 5.04108 14.7478 5.3729L15.7404 6.77915C16.0455 7.21131 16.0455 7.78869 15.7404 8.22085L14.7478 9.6271C14.5135 9.95892 14.1327 10.1562 13.7266 10.1562H10.6242C10.2791 10.1562 9.99925 9.87643 9.99925 9.53125V5.46875C9.99925 5.12357 10.2791 4.84375 10.6242 4.84375Z" stroke="currentColor"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'SignDirectionIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>